import { Paper } from '@material-ui/core'
import { DataGrid } from '@material-ui/data-grid'
import '@material-ui/styles'
import React from 'react'
import { Button } from 'react-bootstrap'

export const CZTabla = ({czs, programa, resetEstado}) => {

    const regresarNacional = (e) => {
        resetEstado(0);
    }

    const columns = [
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 130, field: 'icveie', headerName: 'Clave', type: 'number', sortable: true, hide: true},
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 200, field: 'cdesie', headerName: 'Estado', sortable: true, hide: true },
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 50, field: 'icvecz', headerName: 'CZ', type: 'number', sortable: true},
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 200, field: 'cdescz', headerName: 'Coordinación', sortable: true},
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 100,  field: 'ucn', headerName: 'UCN', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 130,  field: 'participantes', headerName: 'Participantes', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 120,  field: 'incorp', headerName: 'Incorp', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 120,  field: 'reincorp', headerName: 'Reincorp', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'exa_pre_papel', headerName: 'Ex Pre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'exa_acre_papel', headerName: 'Ex Acre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'diag_pre_papel', headerName: 'Diag Pre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'diag_acre_papel', headerName: 'Diag Acre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'exa_pre_linea', headerName: 'Ex Pre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'exa_acre_linea', headerName: 'Ex Acre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'diag_pre_linea', headerName: 'Diag Pre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'diag_acre_linea', headerName: 'Diag Acre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'porc_acre', headerName: 'Acred', hide: true },
    ];

    const columnsPec = [
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 130, field: 'icveie', headerName: 'Clave', type: 'number', sortable: true, hide: true},
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 200, field: 'cdesie', headerName: 'Estado', sortable: true, hide: true },
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 130, field: 'icvecz', headerName: 'CZ', type: 'number', sortable: true},
        { cellClassName: 'tabla-texto2', headerClassName: 'tabla-header', width: 200, field: 'cdescz', headerName: 'Coordinación', sortable: true},
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'participantes', headerName: 'Participantes', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 140,  field: 'incorp', headerName: 'Incorporados', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 160,  field: 'exa_pre_papel', headerName: 'Ex Pre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 160,  field: 'exa_acre_papel', headerName: 'Ex Acre Papel', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 160,  field: 'exa_pre_linea', headerName: 'Ex Pre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 160,  field: 'exa_acre_linea', headerName: 'Ex Acre Linea', type: 'number', sortable: true },
        { cellClassName: 'tabla-texto', headerClassName: 'tabla-header', width: 150,  field: 'porc_acre', headerName: 'Acred', hide: true },
    ]

    return (
        <div style={{padding: "2rem"}} className="animate__animated animate__fadeIn">
            <br />
            <br />
            <br />
            <Button onClick={regresarNacional} variant="secondary" block >Volver a Nacional</Button>
            <br />
            {
                programa === "PR"?
                (
                    <Paper>
                        <div style={{height: "100vh"}}>
                            <DataGrid hideFooterSelectedRowCount={true} 
                                getRowId={(czs) => czs.icvecz} 
                                columns={columns} 
                                rows={czs} 
                                pageSize={20}   />
                        </div>
                    </Paper>
                ) :
                (
                    <Paper>
                        <div style={{height: "100vh"}}>
                            <DataGrid hideFooterSelectedRowCount={true} 
                                getRowId={(czs) => czs.icvecz} 
                                columns={columnsPec} 
                                rows={czs} 
                                pageSize={20}   />
                        </div>
                    </Paper>
                )
            }
        </div>
    )
}
